import "./styles.scss";
import Main from "./screens/Main/Main";
import {BrowserRouter, Link, Route, Routes, Outlet} from "react-router-dom";
import Catalog from "./screens/Catalog/Catalog";
import React from "react";
import Layout from "./screens/Layout";
import Book from "./screens/Book/Book";

export default function App() {

  return (
      <BrowserRouter>
          <div className={'container'}>
              <div className={'inner-container column'}>
                  <Routes>
                      <Route path="/" element={<Layout />}>
                          <Route path="/" element={<Catalog />} />
                          <Route path="/tales/:id" exact element={<Book />} />
                          <Route path="/book" element={<Book />} />
                          <Route path="*" element={<NoMatch />} />
                      </Route>
                  </Routes>
              </div>
          </div>

      </BrowserRouter>
  );
}



function Home() {
  return (
      <div>
        <h2>Home</h2>
      </div>
  );
}

function About() {
  return (
      <div>
        <h2>About</h2>
      </div>
  );
}

function Dashboard() {
  return (
      <div>
        <h2>Dashboard</h2>
      </div>
  );
}

function NoMatch() {
  return (
      <div>
        <h2>Nothing to see here!</h2>
        <p>
          <Link to="/">Go to the home page</Link>
        </p>
      </div>
  );
}
